import CryptoJS from "crypto-js";

// eslint-disable-next-line no-undef
const SECRET_KEY = process.env.REACT_APP_LOGIN_DATA_ENCRYPTION_SECRET_KEY;

if (!SECRET_KEY) {
    throw new Error("REACT_APP_LOGIN_DATA_ENCRYPTION_SECRET_KEY environment variable is not set");
}

export const encryptData = (text) => {
    try {
        if (!text) return "";
        return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
    } catch (error) {
        // console.log("Encryption error:", error);
        return "";
    }
};

export const decryptData = (encryptedText) => {
    try {
        if (!encryptedText) return "";
        const decrypted = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY);
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        // console.log("Decryption error:", error);
        return "";
    }
};
